import { render, staticRenderFns } from "./InputChangePassword.vue?vue&type=template&id=3c5e1f52"
import script from "./InputChangePassword.vue?vue&type=script&lang=js"
export * from "./InputChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports